import { get } from "lodash";

import { ROW_STATE } from "../../../components/forms/formConstants.js";
import { ALL_RESOURCES } from "../../../constants/schedules.js";
import {
  ALL_RESOURCE_KEYS,
  ALL_PLANNER_KEYS
} from "../../../constants/entity.js";
import { DEFAULT_SCHEDULES } from "./configs/defaultSchedulesData.js";

// check for and retrieve default schedules
export function checkForDefaultSchedule(schedule) {
  if (DEFAULT_SCHEDULES[schedule]) {
    return [DEFAULT_SCHEDULES[schedule]];
  }

  if (schedule) {
    return [schedule];
  }

  return null;
}

export function getEstimateScheduleArray(schedule) {
  let schedules = ["always-off", "always-on"];
  if (schedule) schedules.push(schedule);
  return schedules;
}

// creates an object of the structure { workstations:[], containers:[], ... }
// split the resource array and calculate changes based on the passed schedule and array of selected resource ids

export function splitResourceArray(schedule, selectedResources) {
  const resources = ALL_RESOURCES.reduce((acc, value) => {
    const plannerKey = value.plannerKey;
    const planners = schedule ? schedule[plannerKey] : null;
    const parsedPlanners = [];

    // filter resources by @type
    const resources = selectedResources.filter(item => {
      return item.includes(value.URIChunk);
    });

    // new resources
    const newResources = resources.filter(resource => {
      if (!planners) {
        return true;
      } else {
        return (
          planners.findIndex(planner => {
            return planner.resource["@id"] === resource;
          }) < 0
        );
      }
    });

    newResources.forEach(item => {
      parsedPlanners.push({
        "@id": item,
        "@type": value["@type"],
        state: ROW_STATE.NEW
      });
    });

    if (planners) {
      // deleted resources
      const deletedResources = planners.filter(
        planner => !resources.includes(planner.resource["@id"])
      );

      deletedResources.forEach(item => {
        parsedPlanners.push({
          ...item,
          state: ROW_STATE.DELETE
        });
      });
    }

    return acc.concat(parsedPlanners);
  }, []);

  return { resources };
}

export function combinePlannerArrays(data) {
  if (!data) return null;

  const result = ALL_PLANNER_KEYS.reduce((acc, value) => {
    let name = value;
    return data[name] ? acc.concat(data[name]) : acc;
  }, []);

  return result.map(item => {
    return get(item, "resource.@id");
  });
}

// -- OLDER -- //

export function combineResourceArrays(data) {
  if (!data) return null;

  const result = ALL_RESOURCE_KEYS.reduce((acc, value) => {
    let name = value;
    return data[name] ? acc.concat(data[name]) : acc;
  }, []);

  return result.map(item => {
    return item["@id"];
  });
}
